import { Component, Directive, Injectable, OnDestroy } from "@angular/core";
import { Observable, Subscriber } from "rxjs";

@Directive()
export abstract class EventSubscriber<T> implements OnDestroy {
  private subscriber!: Subscriber<T>;

  constructor(
    private onSubscribe: (subscriber: Subscriber<T>) => void,
    private onDispose: (Subscriber: Subscriber<T>) => void,) {

  }

  protected subscribe(): Observable<T> {
    return new Observable<T>(subscriber => this.handleSubscribe(subscriber, this.onSubscribe));
  }

  private handleSubscribe(subscriber: Subscriber<T>, onSubscribe: (subscriber: Subscriber<T>) => void) {
    this.subscriber = subscriber;

    onSubscribe(subscriber);
  }

  ngOnDestroy(): void {
    this.onDispose(this.subscriber);
  }
}